import { useEffect } from 'react';
import {
  getShortTermCarePremiumPerMonth,
  useShortTermCareFiltersActions,
} from '@/features/shop-insurance';

/**
 * Publishes the highest premium among the fetched quotes so the ceiling options
 * can be built from real numbers.
 *
 * Deliberately reads the quotes BEFORE the premium filter is applied —
 * measuring the filtered set would let a low ceiling shrink the options that
 * generated it, and the advisor could never raise it again.
 */
export function useShortTermCarePremiumCeiling(quotes: ShortTermCareQuote[]): void {
  const { setObservedMaxMonthlyPremium } = useShortTermCareFiltersActions();

  const observedMax = quotes.length
    ? Math.max(...quotes.map(getShortTermCarePremiumPerMonth))
    : null;

  useEffect(() => {
    setObservedMaxMonthlyPremium(observedMax);
  }, [observedMax, setObservedMaxMonthlyPremium]);
}
